import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';

const json = {
  1: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P11-E1",
    audio: "img/FriendsPlus/Page11/Audio/audio-e1-p11.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page11/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/tieude-e1-p11.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page11/E1/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page11/E1/5.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/pot.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/7.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/fox.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/9.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/10.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/hop.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/11.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/12.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/rug.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/13.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/14.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/bug.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/15.jpg" },
        {
          url: "img/FriendsPlus/Page11/E1/16.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/sun.mp3",
        },
        { url: "img/FriendsPlus/Page11/E1/17.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page11/E1/18.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P11-E2",
    audio: "img/FriendsPlus/Page11/Audio/audio-e2-p11.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: "img/FriendsPlus/Page11/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page11/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page11/Audio/tieude-e2-p11.mp3",
        },
        { url: "img/FriendsPlus/Page11/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page11/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P11-E3",
    audio: "",
    video: "",
    component: DesignUnderLine,
    hideBtnFooter: true,
    totalInput: 13,
    exerciseKey: "img/FriendsPlus/Page11/E3/Key/answerKey.png",
    question: [],
    questionImage: [
      [
        // Column18
        { url: 'img/FriendsPlus/Page11/E3/71.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page11/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page11/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page11/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page11/E3/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page11/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/7.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/9.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/11.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page11/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page11/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/15.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page11/E3/16.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page11/E3/17.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/18.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page11/E3/19.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/20.jpg', input: 8, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/21.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page11/E3/22.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page11/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/24.jpg', input: 9, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/25.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/26.jpg', input: 10, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/27.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/28.jpg', input: 11, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/29.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page11/E3/30.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page11/E3/31.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/32.jpg', input: 12 },
        { url: 'img/FriendsPlus/Page11/E3/33.jpg', input: 13 },
        { url: 'img/FriendsPlus/Page11/E3/34.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/35.jpg', input: 14 },
        { url: 'img/FriendsPlus/Page11/E3/36.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/37.jpg', input: 15, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/38.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page11/E3/39.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page11/E3/40.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/41.jpg', input: 16, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/42.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/43.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page11/E3/44.jpg', input: 18 },
        { url: 'img/FriendsPlus/Page11/E3/45.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/46.jpg', input: 19 },
        { url: 'img/FriendsPlus/Page11/E3/47.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/48.jpg', input: 20, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/49.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page11/E3/50.jpg' },
      ],
      [
        // Column14
        { url: 'img/FriendsPlus/Page11/E3/51.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/52.jpg', input: 21 },
        { url: 'img/FriendsPlus/Page11/E3/53.jpg', input: 22 },
        { url: 'img/FriendsPlus/Page11/E3/54.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/55.jpg', input: 23 },
        { url: 'img/FriendsPlus/Page11/E3/56.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/57.jpg', input: 24, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/58.jpg' },
      ],
      [
        // Column15
        { url: 'img/FriendsPlus/Page11/E3/59.jpg' },
      ],
      [
        // Column16
        { url: 'img/FriendsPlus/Page11/E3/60.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/61.jpg', input: 25, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/62.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/63.jpg', input: 26 },
        { url: 'img/FriendsPlus/Page11/E3/64.jpg', input: 27 },
        { url: 'img/FriendsPlus/Page11/E3/65.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/66.jpg', input: 28 },
        { url: 'img/FriendsPlus/Page11/E3/67.jpg' },
        { url: 'img/FriendsPlus/Page11/E3/68.jpg', input: 29, isCorrect: true },
        { url: 'img/FriendsPlus/Page11/E3/69.jpg' },
      ],
      [
        // Column17
        { url: 'img/FriendsPlus/Page11/E3/70.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P11-E4",
    audio: '',
    video: '',
    component: MatchDots,
    exerciseKey: "img/FriendsPlus/Page11/E4/Key/answerKey.png",
    // titleQuestion: [{ num: '1', title: 'Listen and draw lines.', color: "#1F4199" }],
    question: {
      DrawLines: {
        multipleLine: false,
        boxMatch: [
          { boxMatchStyle: { position: 'absolute', top: '160px', left: '394px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '280px', left: '394px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '400px', left: '394px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '515px', left: '394px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '630px', left: '394px', width: 100, height: 70 }, },

          { boxMatchStyle: { position: 'absolute', top: '160px', left: '606px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '280px', left: '606px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '400px', left: '606px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '515px', left: '606px', width: 100, height: 70 }, },
          { boxMatchStyle: { position: 'absolute', top: '630px', left: '606px', width: 115, height: 70 }, },
        ],
        answers: ['0-6', '1-9', '2-8', '3-7', '4-5'],
        initialValue: [],
      },
      Layout: `
          <img src='img/FriendsPlus/Page11/E4/1.jpg' />
          <input id='0' type= 'boxMatch' />
          <input id='1' type= 'boxMatch' />
          <input id='2' type= 'boxMatch' />
          <input id='3' type= 'boxMatch' />
          <input id='4' type= 'boxMatch' />

          <input id='5' type= 'boxMatch' />
          <input id='6' type= 'boxMatch' />
          <input id='7' type= 'boxMatch' />
          <input id='8' type= 'boxMatch' />
          <input id='9' type= 'boxMatch' />
      `,
    },
  },
  5: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P11-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page11/E5/1.jpg" }]],
  },
};

export default json;
